var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"randomTweetList",staticClass:"random-tweet-list"},_vm._l((_vm.tweets),function(tweet){return _c('div',{key:tweet.id,ref:"tweets",refInFor:true,staticClass:"tweet-wrapper"},[_c('tweet',{attrs:{"tweet":tweet}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }